import styles from "./style.postcss";

import React from "react";
import classnames from "classnames";
import Detailsboard from "components/Detailsboard";
import ReactGA from "react-ga4";
import PropTypes from "prop-types";

const PageActivitesSeletor = (props) => {
  const { title, isEditMode, activities, onActivityChecked } = props;

  if (isEditMode) {
    return (
      <div className={styles.PageActivitiesSelector}>
        <p className={styles.PageActivitiesSelector_title}>{title}</p>
        <div className={styles.PageActivitesSeletor_activities}>
          {renderEditableActivities()}
        </div>
      </div>
    );
  }

  return <Detailsboard boardTitle={title} boardValue={activitiesString()} />;

  function activitiesString() {
    const result = [<span>Activities: </span>];
    activities.map((activity) => {
      // eslint-disable-line
      const spanStyle = activity.isChecked ? {} : { color: "#a4a4a4" };
      result.push(
        <span style={spanStyle}>{activity.cicActivityItemCode}</span>,
      );
      result.push(<span>, </span>);
    });
    result.pop();
    return result;
  }

  function renderEditableActivities() {
    return activities.map((activity, index) => {
      const activityItemStyle = activity.isChecked
        ? styles.PageActivitiesSelector_activities_activityChecked
        : styles.PageActivitiesSelector_activities_activityUnchecked;
      return (
        <div
          className={classnames(activityItemStyle)}
          onClick={() => activityChecked(index)}
        >
          <span>{activity.cicActivityItemCode}</span>
        </div>
      );
    });
  }

  function activityChecked(index) {
    ReactGA.event({
      category: "Covered in Class",
      action: "Clicked activity",
      label: `Clicked activity ${index}`,
    });

    const newActivities = activities;
    const activity = newActivities.get(index);
    const newActivity = activity.set("isChecked", !activity.isChecked);
    onActivityChecked(props.index, newActivities.set(index, newActivity));
  }
};

PageActivitesSeletor.propTypes = {
  index: PropTypes.int,
  isEditMode: PropTypes.bool,
  title: PropTypes.string.isRequired,
  activities: PropTypes.object.isRequired,
  onActivityChecked: PropTypes.func,
};

export default PageActivitesSeletor;



// WEBPACK FOOTER //
// ./components/PageActivitiesSelector/index.jsx